export { IonDigitKeyboardCmp } from './ion-digit-keyboard-cmp/ion-digit-keyboard-cmp';


// WEBPACK FOOTER //
// ./src/components/ion-digit-keyboard/components/index.ts